import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/moving-and-storage-services.jpg'),
    alt: 'moving and storage services page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'moving and storage services page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Fast <span>Moving</span><span>And Storage Services Available</span>',
  description:
    "ShipAndStorage offers fast, reliable, and affordable moving and storage services for students, businesses, and homeowners. Whether you're relocating, need extra storage space, or shipping boxes, we provide secure and flexible solutions tailored to your needs.",
  image: {
    url: '/images/v2/pages/landing-pages/moving-and-storage-services/hero-image.jpg',
    alt: 'Fast Moving And Storage Services Available'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Register Now' }
}

export const ourProcessSectionContent = {
  title: 'Affordable Moving And Storage Services',
  description: 'We make student storage and shipping affordable through three simple steps:',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/moving-and-storage-services/affordable-moving-and-storage-services.png',
    alt: 'Affordable Moving And Storage Services'
  },

  articles: [
    {
      id: 1,
      title: 'Easy Online Booking',
      description:
        'Schedule your moving and storage services in just a few clicks, selecting pickup and delivery options that suit your timeline.',
      image: {
        src: '/images/v2/pages/common/easy-online-booking.png',
        alt: 'Easy Online Booking'
      }
    },
    {
      id: 2,
      title: 'Cost-Effective Options',
      description:
        'We offer budget-friendly pricing with no hidden fees, plus exclusive student discounts for affordable storage solutions.',
      image: {
        src: '/images/v2/pages/common/cost-effective-options.png',
        alt: 'Cost-Effective Options'
      }
    },
    {
      id: 3,
      title: 'Reliable Nationwide Delivery',
      description:
        'With trusted shipping partners, we ensure safe and on-time delivery of your stored items to any location across the country.',
      image: {
        src: '/images/v2/pages/common/reliable-nationwide-delivery.png',
        alt: 'Reliable Nationwide Delivery'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Secure Moving And Storage Solutions',
  description:
    'Your belongings are safe with us! ShipAndStorage provides climate-controlled storage, advanced security, and real-time tracking to ensure your items are protected. Whether you need short-term storage for a semester or long-term storage for a year, our services guarantee flexibility, security, and convenience.',
  image: {
    src: '/images/v2/pages/landing-pages/moving-and-storage-services/secure-moving-and-storage-solutions.jpg',
    alt: 'Secure Moving And Storage Solutions'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Moving and Storage Services',

  cards: [
    {
      id: 1,
      title: 'Cost Savings',
      description: 'Affordable pricing plans ensure you get the best storage solutions without overspending.',
      image: {
        src: '/images/v2/pages/common/cost-savings.png',
        alt: 'Cost Savings'
      }
    },
    {
      id: 2,
      title: 'Convenience',
      description: 'From pickup to delivery, we handle everything, making the storage and moving process hassle-free.',
      image: {
        src: '/images/v2/pages/common/easy-access-and-convenience.png',
        alt: 'Convenience'
      }
    },
    {
      id: 3,
      title: 'Flexible Storage Plans',
      description: 'Choose between short-term and long-term storage options, designed to fit your specific needs.',
      image: {
        src: '/images/v2/pages/common/affordable-storage-plans.png',
        alt: 'Flexible Storage Plans'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Choose Us for College Boxes Storage Services?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Students Relocating for College',
          description: 'Moving to a dorm? Our services ensure a smooth and stress-free transition.'
        },
        {
          id: 2,
          title: 'Parents Managing Student Storage',
          description:
            "We offer safe and affordable storage solutions, so parents don’t have to worry about their children's belongings."
        },
        {
          id: 3,
          title: 'International Students',
          description: 'Hassle-free storage and shipping solutions for students moving from abroad to the U.S.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/moving-and-storage-services/who-should-choose-us-for-college-boxes-storage-services.jpg',
        alt: 'Who Should Choose Us for College Boxes Storage Services?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Different Storage Services',

  cards: [
    {
      id: 1,
      title: 'Business Storage Solution',
      description:
        'A secure and cost-effective way to store inventory, office files, and equipment with convenient retrieval and delivery options.',
      image: {
        src: '/images/v2/pages/common/business-storage-solution.png',
        alt: 'Business Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Luggage and Box Shipping Services',
      description:
        'Ship your luggage, boxes, and personal belongings both domestically and internationally with top shipping carriers.',
      image: {
        src: '/images/v2/pages/common/luggage-and-box-shipping-services.png',
        alt: 'Luggage and Box Shipping Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Moving Storage Solution',
      description:
        "Whether you're moving between dorms, apartments, or offices, our moving storage service provides a safe space for your belongings.",
      image: {
        src: '/images/v2/pages/common/moving-storage-solution.png',
        alt: 'Moving Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'Residential Storage Services',
      description:
        'Perfect for homeowners undergoing renovations, moving, or needing long-term storage solutions for extra belongings.',
      image: {
        src: '/images/v2/pages/common/business-furniture-storage.png',
        alt: 'Residential Storage Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose ShipAndStorage for Moving and Storage Services?',

  image: {
    url: '/images/v2/pages/landing-pages/moving-and-storage-services/why-choose-shipandstorage-for-moving-and-storage-services.jpg',
    alt: 'Why Choose ShipAndStorage for Moving and Storage Services?'
  },

  articles: [
    {
      id: 1,
      title: 'Affordable Pricing',
      description: 'Competitive pricing with no hidden fees ensures a budget-friendly storage solution.'
    },
    {
      id: 2,
      title: 'Reliable Shipping Partners',
      description: 'Our partnerships with FedEx, DHL, and UPS guarantee secure and timely deliveries.'
    },
    {
      id: 3,
      title: 'Flexible Storage Plans',
      description: 'We offer short-term and long-term storage options based on your specific needs.'
    },
    {
      id: 4,
      title: 'Student-Friendly Services',
      description: 'Specially designed services for students needing affordable and flexible storage solutions.'
    },
    {
      id: 5,
      title: 'Secure Storage Facilities',
      description: 'Climate-controlled and security-monitored storage units keep your items safe.'
    },
    {
      id: 6,
      title: 'Convenient Pickup & Delivery',
      description: 'Hassle-free pickup and delivery at your convenience, making storage stress-free.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Secure and Affordable Storage Services',
  description:
    'Reliable shipping and storage services for all locations. Fast, secure, and affordable solutions tailored to meet your specific storage and shipping needs.',
  image: {
    src: '/images/v2/pages/landing-pages/moving-and-storage-services/secure-and-affordable-storage-services.png',
    alt: 'Secure and Affordable Storage Services'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Get Started' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Storage Partners',
  description:
    'At ShipAndStorage, we collaborate with top logistics providers to offer reliable, secure, and efficient moving and storage services for our customers.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx is a globally recognized leader in logistics, ensuring that your belongings are stored and transported with the utmost security and efficiency.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more details, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL provides secure and reliable logistics solutions, ensuring your storage and shipping needs are met efficiently, whether for short-term or long-term storage.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy or completeness of the information provided. For more details, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS offers secure storage and global shipping services, ensuring your items are handled with care and delivered on time.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more details, visit <a href='https://www.ups.com/' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
